<div class="b-container modal2">
    <div class="b-row header">
        <div class="b-col-12">
            {{ header }}
        </div>
    </div>
    <div class="b-row">
        <div class="b-col-12">
            <div class="body">
                <h1 class="b-mt-3">Use an email address you'll always have access to.</h1>

                <h2 class="b-mt-3">New Email Address</h2>
                <input [(ngModel)]="newEmail" class="input" />

                <h2 class="b-mt-3">Confirm New Email Address</h2>
                <input [(ngModel)]="newEmailConfirm" class="input" />

                <div class="footer-buttons">
                    <div class="left">
                        <ion-button class="left" fill="outline" color="secondary" size="medium" type="button" class="default-btn" (click)="dismiss()">
                            Cancel
                        </ion-button>
                    </div>

                    <div class="right">
                        <ion-button
                            (click)="submit()"
                            [disabled]="!newEmail || newEmail !== newEmailConfirm"
                            fill="solid"
                            color="secondary"
                            size="medium"
                            type="button"
                            class="default-btn"
                        >
                            Update
                        </ion-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
